import Vertical from './Vertical.jsx';

export default Vertical;



// WEBPACK FOOTER //
// ./src/pages/Search/Main/Vertical/index.js